import { has } from 'lodash';
import { createAutocomplete } from '@algolia/autocomplete-core';

// Context types

// Expected shape of Algolia hits for various indexes:

export function isPageHit(hit) {
  return has(hit, 'isNewTab');
}
export function isEmbeddedSearchProps(props) {
  return typeof props.showFixedQuery === 'string';
}
export let Segment = /*#__PURE__*/function (Segment) {
  Segment["stores"] = "stores";
  Segment["nationalStorefronts"] = "nationalStorefronts";
  Segment["sites"] = "sites";
  Segment["services"] = "services";
  Segment["localOffers"] = "localOffers";
  Segment["nationalOffers"] = "nationalOffers";
  Segment["events"] = "events";
  Segment["localNews"] = "localNews";
  Segment["nationalNews"] = "nationalNews";
  Segment["localStories"] = "localStories";
  Segment["nationalStories"] = "nationalStories";
  Segment["centres"] = "centres";
  Segment["onlineServices"] = "onlineServices";
  Segment["otherStores"] = "otherStores";
  Segment["westfieldProducts"] = "westfieldProducts";
  Segment["searchSuggestions"] = "searchSuggestions";
  return Segment;
}({});
export function isSegment(maybeSegment) {
  return maybeSegment in Segment;
}
export function assertSegment(maybeSegment) {
  if (isSegment(maybeSegment)) {
    return maybeSegment;
  } else {
    throw new Error("Unknown segment ".concat(maybeSegment));
  }
}

// Unfortunately we need to do this rather than just
// a ternary to get the discriminated union business
// working
// Render types
// Autocomplete types
// To be compatible with the BaseItem type that all the Algolia
// Algola's Event types for onClick handlers and the like don't
// match what React expects. So we have to replace the types of
// some of the keysf of AutocompleteApi leaving as much intact as
// we can
// Not sure if there's a more readable way to sequentially rework
// a type like this...
// Trick to get types out of a generic function
export const createAutocompleteMyType = createAutocomplete;